<!-- Created by Maxim B. on 05/05/20.-->
<!-- Copyright © 2020 Curriculum Ltd. All rights reserved.-->

<div class="initials-container">
  <span class="user-initials" [style]="{'font-size': size}">{{initials}}</span>
</div>

